/**
 * export — the English half, typed against the German module, so a
 * missing or misspelled key is a type error in this file.
 */
import type { exportKeys as de_exportKeys } from '../de/export';

export const exportKeys: Record<keyof typeof de_exportKeys, string> = {
  /* ---------------- the form as a PDF ---------------- */
  'export.pdf.title': 'LBA form as PDF',
  'export.pdf.line': 'The filled-in original form – exactly as in the Form tab.',
  'export.pdf.info':
    'The PDF is the document for the kneeboard, and it prints from the browser. Printing this page does not produce a form.',
  'export.pdf.btn': 'Download PDF',
  'export.pdf.busy': 'Creating the PDF …',
  'export.pdf.preview': 'Preview',
  'export.pdf.err': 'The PDF could not be created.',
  'export.pdf.complete': 'Every important field is filled in.',
  'export.pdf.missing': 'Still open: {list}',
  'export.pdf.missing.more': 'Still open: {list} · +{n} more',

  /* ---------------- the share link ---------------- */
  'export.share.title': 'Share a link',
  'export.share.line': 'Anyone with the link can see the flight – no account, no changes.',
  'export.share.btn': 'Create a link',
  'export.share.busy': 'Creating the link …',
  'export.share.copied': 'copied',
  'export.share.local': 'This flight lives in this browser only. Sign in and it can be shared.',

  /* ---------------- the file ---------------- */
  'export.file.title': 'File',
  'export.file.line': 'Save every value as a file – or read a file back in and carry on planning.',

  /* ---------------- what is coming ---------------- */
  'export.soon.title': 'More templates',
  'export.soon.line': 'In progress – coming in one of the next versions.',
  'export.soon.navlog': 'Navigation log as a PDF',
  'export.soon.fpl': 'ICAO flight plan',
  'export.soon.wx': 'Weather briefing as a PDF',
};
